import getEnv from '@/utils/get-env';
import type { Plugin } from '@segment/analytics-next';
import type { ValidSegmentEventProperties } from './types';

export function obfuscateKeyValues(
  obj: Record<string, unknown>,
  keys: string[]
) {
  const obfuscatedObj: Record<string, unknown> = {};

  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      obfuscatedObj[key] = keys.includes(key)
        ? String(obj[key]).replaceAll(/./g, '*')
        : obj[key];
    }
  }

  return obfuscatedObj;
}

const obfuscatedSearchKeys = [
  'name',
  'address',
  'city',
  'date',
  'ssn',
  'email',
  'organization',
  'occupation',
  'phone',
  'postal_code',
  'address',
  'regID',
  'day',
  'month',
  'year',
  'notes',
  'personalID',
  'zipcode',
] satisfies ValidSegmentEventProperties;

const obfuscatedGeneralKeys = [
  'address_city',
  'address1',
  'date_of_birth',
  'first_name',
  'last_name',
  'nationality',
  'query',
  'description',
] satisfies ValidSegmentEventProperties;

export const obfuscatedKeys = [
  ...obfuscatedSearchKeys,
  ...obfuscatedGeneralKeys,
];

const { isDev } = getEnv();
export const obfuscateEventPropertiesPlugin: Plugin = {
  name: 'Obfuscate Event Properties',
  type: 'before',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  page: (ctx) => {
    if (isDev) {
      // NOTE: Used for local development.
      console.info(
        'debug: [Segment Routes Tracking]:',
        '\n',
        `${ctx.event.type}: ${ctx.event.properties?.name}`
      );
    }

    return ctx;
  },

  track: (ctx) => {
    if (
      Object.keys(ctx.event.properties as Record<string, unknown>).length > 0
    ) {
      ctx.updateEvent(
        'properties',
        obfuscateKeyValues(
          ctx.event.properties as Record<string, unknown>,
          obfuscatedKeys
        )
      );
    }

    if (isDev) {
      // NOTE: Used for local development.
      console.info(
        'debug: [Segment Analytics Tracking]:',
        '\n',
        ctx.event.event,
        '\n',
        ctx.event.properties
      );
    }

    return ctx;
  },
};
